import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { labourBookingApi } from '../api/labourBookingApi'; 
import { RootState } from '..';

export interface LabourBookingState {
  labourBookingDetails: any;
  loading: boolean;
  error: string | null;
  data: [] | null | any;
  totalPage: number | null;
  currentPage: number | null;
  totalRecords: number | null;
}

const initialState: LabourBookingState = {
  labourBookingDetails: null,
  loading: false,
  error: null,
  data: null,
  totalPage: null,
  currentPage: null,
  totalRecords: null,
};

const labourBookingSlice = createSlice({
  name: 'labourBooking',
  initialState,
  reducers: {
    setLabourBookingDetails: (state, action: PayloadAction<any>) => {
      state.labourBookingDetails = action.payload;
      state.data = action.payload.data;
      state.totalPage = action.payload.totalPage;
      state.currentPage = action.payload.currentPage;
      state.totalRecords = action.payload.totalRecords;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    reset: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        labourBookingApi.endpoints.lineUpLabourWithBooking.matchPending,
        (state) => {
          state.loading = true;
        }
      )
      .addMatcher(
        labourBookingApi.endpoints.lineUpLabourWithBooking.matchFulfilled,
        (state, action) => {
          state.loading = false;
          state.labourBookingDetails = action.payload;
          state.error = null;
        }
      )
      .addMatcher(
        labourBookingApi.endpoints.lineUpLabourWithBooking.matchRejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error.message || 'Something went wrong';
        }
      );
  },
});

// Action creators are generated for each case reducer function
export const { setLabourBookingDetails, setLoading, setError, reset } = labourBookingSlice.actions;
export const getLabourBookingDetails = (state: RootState) => state.labourBooking.data;
export const getLabourBookingTotalRecords = (state: RootState) => state.labourBooking.totalRecords;

export default labourBookingSlice.reducer;